<template>
  <div class="materialproductversion-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('materialproductversion_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.productversions')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <MaterialProductVersionFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
            @contextmenu:row="showHandlerExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import MaterialProductVersionFilterForm from '../../components/materialproductversion/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'MaterialProductVersionList',
  servicePrefix: 'MaterialProductVersion',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    MaterialProductVersionFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.uuid'), value: 'uuid' },
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.reference'), value: 'reference' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['id'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('materialproductversion', {
      items: 'list'
    }),
    ...mapFields('materialproductversion', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('materialproductversion', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
